import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zeroth',
  templateUrl: './zeroth.component.html',
  styleUrls: ['./zeroth.component.scss']
})
export class ZerothComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
